export default __webpack_public_path__ + "8289474f88789df1ae6bad0508fbfb98.svg";